import { useNavigate } from "react-router-dom";
import SettingsPage from "./SettingsPage";
import { useAuthStore } from "@/store/auth";
import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/heading";
import { Icons } from "@/components/icons";
import PageContainer from "@/components/layout/page-container";
import { useEffect } from "react";
import { showToast } from "@/components/ui/show-toast";

export default function SettingsPageNoEntity() {
  const activeWorkspace = useAuthStore(state => state.activeWorkspace);
  const logout = useAuthStore(state => state.clearAuthData);
  const navigate = useNavigate();

  useEffect(() => {
    if (activeWorkspace) {
      navigate('/dashboard/settings', { replace: true });
    } else {
      showToast('error', 'Something went wrong! You do not have any organisation or workspace');
    }
  }, [activeWorkspace, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/sign-in');
  };

  return (
    <PageContainer scrollable={true}>
      <div className="space-y-6">
        {/* Header Section */}
        <div className="flex items-center justify-between">
          <Heading 
            title="Settings" 
            description="Manage your account settings and preferences" 
          />
          <Button 
            variant="outline" 
            onClick={handleLogout}
            className="flex items-center gap-2"
          >
            <Icons.login className="h-4 w-4" />
            Logout
          </Button>
        </div>

        {/* Settings Content */}
        <div className="rounded-lg border bg-white p-6 shadow-sm">
          <SettingsPage />
        </div>
      </div>
    </PageContainer>
  );
}